<template>
    <div class="footer">
        Использование материалов с сайта без разрешения владельца запрещено.<br>
        По интересующим вопросам обращайтесь по номеру <a href="tel:+38268454710">+382 (68) 454 710</a>
        или по электронной почте: <a href="mailto:clients@wd-cleaning.me">clients@wd-cleaning.me</a>.<br>
        WD Cleaning Montenegro © {{ year }}<br>
    </div>
</template>

<script>
  export default {
    name: 'rfooter',
    data() {
      return {
        year: (new Date()).getFullYear()
      }
    }
  }
</script>

<style lang="scss" scoped>
    @import '../assets/vars';

    .footer {
        font-size: 12px;
        padding: 20px 80px;
        background-color: $color-border;
        color: #444;
        text-align: center;
        margin-top: 60px;
    }

    @media (max-width: 767px) {
        .footer {
            padding: 20px 20px;
        }
    }
</style>
